import React, { Component } from "react";
import { Statistic, Row, Col, Tooltip, Icon } from "antd";

class SeatInput extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { statisData } = this.props;
    return (
      <Row style={{ marginBottom: "16px" }} className="seat-statis">
        <Col span={4}>
          <Statistic
            title={
              <div>
                全年合同收入
                <Tooltip title="当年已经收到的所有金额">
                  <Icon style={{ marginLeft: "3px" }} type="question-circle" />
                </Tooltip>
              </div>
            }
            value={statisData.sum}
            suffix="元"
          />
        </Col>
        <Col span={4}>
          <Statistic
            title={
              <div>
                月收入峰值
                <Tooltip title="每个工位数量*租金的总和">
                  <Icon style={{ marginLeft: "3px" }} type="question-circle" />
                </Tooltip>
              </div>
            }
            value={statisData.monthSum}
            suffix="元"
          />
        </Col>
        <Col span={4}>
          <Statistic
            title={
              <div>
                总入驻率
                <Tooltip title="本年内的每份合同约定入驻天数工位数的总和  / （365工位总数）">
                  <Icon style={{ marginLeft: "3px" }} type="question-circle" />
                </Tooltip>
              </div>
            }
            value={statisData.immigrationRate}
            suffix="%"
          />
        </Col>
        <Col span={4}>
          <Statistic
            title={
              <div>
                月入驻率
                <Tooltip title="本月内的每份合同约定入驻天数工位数的总和  / （30工位总数）">
                  <Icon style={{ marginLeft: "3px" }} type="question-circle" />
                </Tooltip>
              </div>
            }
            value={statisData.monthImmigrationRate}
            suffix="%"
          />
        </Col>
        <Col span={4}>
          <Statistic
            title={
              <div>
                工位平均月租
                <Tooltip title="（每个工位*工位单价）求和 / 工位总数">
                  <Icon style={{ marginLeft: "3px" }} type="question-circle" />
                </Tooltip>
              </div>
            }
            value={statisData.avg}
            suffix="元"
          />
        </Col>
      </Row>
    );
  }
}
export default SeatInput;



// WEBPACK FOOTER //
// ./src/components/incubator/seat/SeatStatic.js